var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompleteStepGreen = function SvgCompleteStepGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "stepper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Step Counter",
    transform: "translate(3.951 -.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(-3.951 .049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.257 11.437a1.373 1.373 0 0 0-1.95 0L11.076 21.682l-4.3-4.312a1.403 1.403 0 1 0-1.95 2.019l5.273 5.273a1.373 1.373 0 0 0 1.95 0l11.208-11.206a1.373 1.373 0 0 0 0-2.019Z",
    "data-fill": "a"
  }))));
};
export default SvgCompleteStepGreen;